import { Component, HostListener, OnInit } from '@angular/core';
import { CalAngularService } from '@cvx/cal-angular';
import { PageLayout } from '@cvx/nextpage';
import { PrimaryUserAuthService } from 'src/app/services/primaryUserAuth/primaryUserAuth.service';

@Component({
  selector: 'app-create-primary-user',
  templateUrl: './create-primary-user.component.html'
})
export class CreatePrimaryUserComponent implements OnInit {

  PageLayout = PageLayout;
  IsAuthorised: boolean = false;
  showCreatePageAlert: boolean = true;

  constructor(private authService: CalAngularService, private primaryUserAuthService: PrimaryUserAuthService) { }

  async ngOnInit(): Promise<void> {
    const cvxClaimsPrincipal = this.authService.cvxClaimsPrincipal;
    this.IsAuthorised = this.primaryUserAuthService.GetPageAuthorization(cvxClaimsPrincipal);

    const createPageBannerClosed = localStorage.getItem('createPageBannerClosed');
        if (createPageBannerClosed === 'true') {
            this.showCreatePageAlert = false;
    }
  }

  @HostListener('click', [`$event`])
  closeAlert(event: MouseEvent) {
      if ((event.target as HTMLElement).id === 'alert-shim-close') {
          this.showCreatePageAlert = false;
          localStorage.setItem('createPageBannerClosed', 'true');
          event.preventDefault();
      }
  }
}
